import "./site.css";
import { legacyHashTarget } from "./legacy";

declare global {
  interface Window {
    tt_event?: (name: string, metadata?: Record<string, unknown>) => void;
  }
}

const legacyTarget = legacyHashTarget(window.location.hash);
if (legacyTarget) window.location.replace(legacyTarget);

// The app keeps this key while someone is signed in, so they get a direct way back in.
try {
  if (window.localStorage.getItem("button.auth.method")) {
    for (const link of document.querySelectorAll<HTMLAnchorElement>("a[data-auth-link]")) {
      link.textContent = "Open app";
      link.href = "/app";
    }
  }
} catch (error) {
  console.warn("sign-in state unavailable", error);
}

// Copy buttons render hidden so nothing dead shows without JavaScript.
for (const button of document.querySelectorAll<HTMLButtonElement>("button[data-copy]")) {
  const source = document.getElementById(button.dataset.copy ?? "");
  if (!source) continue;

  const label = button.textContent ?? "Copy";
  button.hidden = false;
  button.addEventListener("click", () => {
    navigator.clipboard
      .writeText(source.textContent?.trim() ?? "")
      .then(() => flash(button, "Copied", label))
      .catch((error: unknown) => {
        console.warn("copy failed", error);
        flash(button, "Select and copy", label);
      });
  });
}

function flash(button: HTMLButtonElement, text: string, label: string): void {
  button.textContent = text;
  window.setTimeout(() => {
    button.textContent = label;
  }, 1600);
}

// The analytics tag loads async, so a click before it arrives simply isn't counted.
document.addEventListener("click", (event) => {
  const cta =
    event.target instanceof Element ? event.target.closest<HTMLElement>("[data-cta]") : null;
  if (!cta || typeof window.tt_event !== "function") return;
  try {
    window.tt_event("cta_click", { placement: cta.dataset.cta, path: window.location.pathname });
  } catch (error) {
    console.warn("analytics event failed", error);
  }
});
